const getTypedKeys = <T extends Record<string, unknown>>(
  object: T
): Array<keyof T> => Object.keys(object) as Array<keyof T>

export const isDeepEqual = <
  Key extends keyof T,
  T extends Record<Key, unknown>,
>(
  object1: T,
  object2: T
): boolean => {
  if (Object.keys(object1).length !== Object.keys(object2).length) return false
  const keys = getTypedKeys(object1)

  for (const key of keys) {
    const value1 = object1[key]
    const value2 = object2[key]

    const isObjects = isObject(value1) && isObject(value2)

    if (
      (isObjects && !isDeepEqual(value1, value2)) ||
      (!isObjects && value1 !== value2)
    ) {
      return false
    }
  }
  return true
}

const isObject = (object: unknown): object is object =>
  object != null && typeof object === 'object'
